import { schema } from "normalizr";
export const disclaimer = new schema.Entity("disclaimer");
export const disclaimersSchema = new schema.Entity("disclaimers", {
  disclaimers: [disclaimer]
});